import React, {useCallback, useEffect} from 'react';
import {connect} from "react-redux";
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    useMediaQuery,
    useTheme
} from "@mui/material";
import {websiteDomainsActions} from "../../store/actions/websiteDomainsAction";
import {useHistory, useLocation, useParams} from "react-router-dom";

import {WebsiteDialog as Dialog, WebsiteCnameRecords} from "./WebsitesDesign";
import {SettingsDialogDescription} from "../settings/SettingsDialog";

function DomainsGetCNAMERecords(props) {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const history = useHistory();
    const location = useLocation();
    const {id} = useParams();

    const {getDomainVerifyRecords} = props;

    const handleClose = useCallback(() => {
        history.push({pathname: "/websites/domains", state: {from: location}});
    }, [history, location]);

    useEffect(() => {
        if (id > 0) {
            getDomainVerifyRecords(id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Dialog
            loading={props?.websiteDomainsState?.isLoading}
            open={true}
            onClose={handleClose}
            fullWidth={true}
            fullScreen={fullScreen}
            aria-labelledby="cname-records-dialog"
            maxWidth="sm"
        >
            <DialogTitle id="cname-records-dialog">Domain CNAME records
                <SettingsDialogDescription>Use these DNS records to verify ownership of your domain.</SettingsDialogDescription>
            </DialogTitle>
            <DialogContent>
                <WebsiteCnameRecords record={props?.websiteDomainsState?.cnameRecord}/>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit" variant="outlined" disabled={props?.websiteDomainsState?.isLoading}>Close</Button>

            </DialogActions>
        </Dialog>
    );
}

const mapStateToProps = (state) => {
    return {
        websiteDomainsState: state.websiteDomains,
    }
};

const mapDispatchToProps = {
    getDomainVerifyRecords: websiteDomainsActions.getDomainVerifyRecords,
};

export default connect(mapStateToProps, mapDispatchToProps)(DomainsGetCNAMERecords);
